<template>
  <div>
    <!-- 新精选课程 -->
    <!-- 以下注释都是联调时需要的 所以暂时保留！ -->
    <li class="dkillItem">
      <p class="dkillTitle" @click="enterDetails(item)">
        <i v-if="item.name && item.name.substr(0, 1) == '【'"></i>{{ item.name }}
      </p>
      <div class="activityTag">
        <TagComponent
          v-for="(tagItem, tagIndex) in (item.discountLabelList || [])"
          :key="tagIndex"
          :text="tagItem"
          :color=" ['套餐','电子书'].includes(tagItem) ? 'blue' : 'yellow-no-bg'"
        />
        <!-- 试听 -->
        <div class="audition" v-if="item.isExistsAudition === 1" @click.stop="enterLive(item)">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/audition.png"
            alt=""
          />
        </div>
      </div>
      <div class="TimeHours" @click="enterDetails(item)">
        <p class="Time" v-if="item.startTime">
          开课时间<span>{{ item.startTime | changeDeadLineTime }}</span
          ><em>|</em>
        </p>
        <p class="time1" v-if="(item?.isEbook) && item.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/player/ebook_icon.png" /> {{ item.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson }}
        </p>
        <p class="hourse" v-if="item.classPeriod && item?.isEbook">
          课时<span>{{ item.classPeriod }}</span>
        </p>
      </div>

      <!-- 教师头像 -->
      <ol class="teacherList" @click="enterDetails(item)">
        <ul v-if="item.teacherRespVOS">
          <li
            v-for="(teacherItem, teaind) in item.teacherRespVOS.length > 3
              ? item.teacherRespVOS.slice(0, 3)
              : item.teacherRespVOS"
            :key="teaind"
          >
            <div class="teabg">
              <img :src="teacherItem.teacherHead || defaultImg" alt="" />
            </div>
            <p>{{ teacherItem.name }}</p>
          </li>
        </ul>
        <!-- 售价 -->
        <div class="coursePrice">
          <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
          <span
            class="courseType"
            v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
            >拼团价</span
          >
          <span v-else-if="item.promotionLabel" class="courseType">{{
            item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
          }}</span>
          <p class="showPic">
            <template
              v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
            >
              <b>¥</b>
              <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
            </template>
            <template v-else>
              <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
              <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
              }}</span>
            </template>
          </p>
        </div>
      </ol>
      <div class="dkillCardBto">
        <p class="endTime">{{ item.salesVolume }}人已购买</p>
        <div class="consultBtn" @click="openChat">立即咨询</div>
      </div>
    </li>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import TagComponent from '@/components/commonComponents/TagComponent.vue';
import defaultImg from '../../../assets/img/loginImg/default.png';

export default {
  components: {
    TagComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImg,
    };
  },
  methods: {
    coursePriceDel(item) {
      return item.productDiscountRespVO.isGroupDiscount || item.promotionLabel;
    },
    // 进入详情
    enterDetails(courseInfo) {
      if (!this.userInfo?.id) {
        this.$emit('showLogin');
        return;
      }
      const { productId } = courseInfo;
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'goCourseDetailParams',
          {
            courseId: productId,
            params: '&source=svipCourse',
          },
          false,
        );
        return;
      }
      // 小程序
      if (this.$root.$data.miniprogram) {
        const url = `${window.location.origin}/ark/courseDetail?courseId=${productId}&source=svipCourse`;
        const jumpUrl = `/subPackages/detailWebView/index?url=${encodeURIComponent(
          url,
        )}&isNeedLogin=0`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      sessionStorage.setItem('back', true);
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: productId,
          source: 'svipCourse',
        },
      });
    },
    //
    enterLive(item) {
      if (this.$root.$data.isApp) {
        // App
        this.$sendToApp(
          'goTrialCoursePage',
          {
            courseId: item.productId,
            productCurriculumId: item.containCurriculumId,
            courseName: item.name,
          },
          false,
        );
      } else {
        sessionStorage.setItem('back', true);
        this.$router.push({
          path: '/audition',
          query: {
            coursesId: item.productId,
            containCurriculumId: item.containCurriculumId,
          },
        });
      }
    },
    openChat() {
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=665818671c64a1000119f4b2';
      if (this.$root.$data.isApp) {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66696197735feb0001e5a925';
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  margin-bottom: 32px;
  // padding: 18px 29px 22px 29px;
  background: linear-gradient(180deg, #fffaf2 0%, #fff9e9 100%);
  border: 1px solid #ffe7cb;
  border-radius: 14px;
}

.dkillTitle {
  display: -webkit-box;
  // text-overflow: ellipsis;
  // -webkit-line-clamp: 2;
  // -webkit-box-orient: vertical;
  padding: 18px 29px 0 29px;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 33px;
  line-height: 45px;
  @extend .ellipsis-2;
  i {
    margin-left: -18px;
  }
}
.activityTag {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin: 9px 5px 11px 0;
  padding-left: 29px;
  font-size: 0;

  .tag-component {
    margin-right: 14px;
  }
}
.TimeHours {
  display: flex;
  align-items: center;
  padding: 0 29px 0 29px;
  line-height: 30px;
  p {
    margin-right: 14px;
    color: #999;
    font-size: 24px;
  }
  span {
    margin-left: 12px;
    color: #999;
    font-size: 24px;
  }
  em {
    margin-left: 12px;
    font-style: normal;
  }
  .time1 {
    display: flex;
    align-items: flex-start;
    align-items: center;
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
    img {
      width: 24px;
      margin-right: 5px;
    }
  }
}
.teacherList {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 33px;
  padding: 0 29px 0 29px;
  ul {
    display: flex;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // width: 64px;
      margin-right: 14px;
      .teabg {
        width: 63px;
        height: 63px;
        background-color: $teabg;
        border-radius: 50%;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      p {
        max-width: 120px;
        margin-top: 9px;
        overflow: hidden;
        color: #999;
        font-size: 20px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.coursePrice {
  position: absolute;
  right: 29px;
  bottom: 5px;
  display: flex;
  align-items: baseline;
  del {
    margin-right: 11px;
    color: $delcolor;
    font-size: 24px;
  }
  .courseType {
    color: #ff3938;
    font-weight: 500;
    font-size: 24px;
  }
}
.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
  b {
    margin: 0 4px;
    color: #ff3938;
    font-size: 25px;
  }
  span {
    color: #ff3938;
    font-weight: bold;
    font-size: 36px;
  }
  .fontSty {
    font-size: 30px;
  }
}
.dkillCardBto {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 13px;
  padding: 10px 29px 16px 29px;
  padding-top: 20px;
  background: #fff;
  border-top: 2px solid rgba(151, 151, 151, 0.1);
  border-radius: 0 0 14px 14px;
  zoom: 1;
}

.audition {
  position: absolute;
  top: 0;
  right: -37px;
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 18px;
  color: $liveColor;
  font-weight: 500;
  font-size: 24px;
  background: #fff;
  border-radius: 19px 0 0 19px;
  img {
    width: 92;
    height: 34px;
    // margin-left: 10px;
  }
}
.endTime {
  float: right;
  color: #999;
  font-size: 24px;
  span {
    color: #999;
    font-size: 24px;
  }
}
.consultBtn {
  width: 116px;
  height: 34px;
  color: #fff;
  font-weight: 400;
  font-size: 22px;
  line-height: 34px;
  text-align: center;
  background: linear-gradient(90deg, #e7a754 0%, #bc783d 100%);
  border-radius: 17px;
}
.yellow-no-bg {
  height: 34px !important;
  color: #fff !important;
  line-height: 34px !important;
  background: #e6bc81 !important;
}
</style>
